// extracted by mini-css-extract-plugin
export default {"checkboxWrapper":"Checkbox_checkboxWrapper__DOd3p","checkbox":"Checkbox_checkbox__1Jx4I","checkboxPulse":"Checkbox_checkboxPulse__nh9wf","checkmark":"Checkbox_checkmark__T5IFj"};